import { Box, Divider as MuiDivider } from '@mui/material';
import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithChildren,
  PropsWithoutRef,
  RefAttributes,
} from 'react';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Size = 'small' | 'medium' | 'full';

type Props = PropsWithChildren<{
  size?: Size;
  tid?: string;
}>;

const WIDTH_BY_SIZE: Record<Size, string> = {
  small: '50%',
  medium: '75%',
  full: '100%',
};

export const divider: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const { size = 'full', children, tid } = props;

  return (
    <Box ref={ref} sx={{ width: WIDTH_BY_SIZE[size], alignSelf: 'center' }} data-testid={tid}>
      <MuiDivider>{children}</MuiDivider>
    </Box>
  );
});

divider.displayName = 'SiloReal-Form-Divider';
